import { FOLLOW_USERS_LIST } from "../apiRoutes";
import { getDataINSTANCE } from "../controller";

export const getFollowersList = async (Id,workSpaceId,search, pageNo = 1, pageSize = 10) => {
      const data  = await getDataINSTANCE(`${FOLLOW_USERS_LIST}?userId=${Id}&workSpaceId=${workSpaceId}&search=${search}&pageNo=${pageNo}&pageSize=${pageSize}`, "Failed to fetch followers list");
      return data;
  } 